import React from 'react'

export default function Footer() {
    const currentYear = new Date().getFullYear();


    return (
        <div style={{
            backgroundColor: "#0000002e",
            padding: "10px",
            verticalAlign: "middle",
            display: "flex",
            marginTop: "5rem",
            justifyContent: "center",
            alignItems: "center",
            // position: "absolute",
            // bottom: "0",
            // left: "0",
            // width: "100%",
        }}>
            <p style={{ fontWeight: "bolder" }}>
                Copyright ©️ {currentYear} Diaba. All rights reserved.
            </p>
        </div>
    )
}
